<div class="main-container" style="max-width: 100%">
  <div class="page-header">
    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
      <mat-chip-set>
        <mat-chip
          [color]="'primary'"
          *ngFor="let item of wallboards"
          [removable]="false"
          [highlighted]="selectedWallboard?.name === item.name"
          (click)="onWallboardClick(item)"
        >
          <span>{{ item.display }}</span>
        </mat-chip>
      </mat-chip-set>
      <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
        <button
          mat-stroked-button
          matTooltip="Add Widget"
          [matMenuTriggerFor]="menu"
          *ngIf="isEditing && getAvailableWallboardItems().length > 0">
          <mat-icon style="margin: 0">add</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item *ngFor="let item of getAvailableWallboardItems()" (click)="addWidget(item)">
            <mat-icon>{{ item.icon }}</mat-icon>
            <span>{{ item.title }}</span>
          </button>
        </mat-menu>
        <button
          type="button"
          mat-stroked-button
          matTooltip="Edit wallboard"
          *ngIf="!isEditing"
          (click)="startEditWallboard()">
          <mat-icon style="margin: 0">edit</mat-icon>
        </button>

        <button
          *ngIf="!isEditing"
          type="button"
          mat-stroked-button
          matTooltip="Enter Full Screen"
          class="fullscreen-enter"
          (click)="toggleFullScreen(true)">
          <mat-icon style="margin: 0">fullscreen</mat-icon>
        </button>

        <button
          *ngIf="!isEditing"
          type="button"
          mat-stroked-button
          matTooltip="Exit Full Screen"
          class="fullscreen-exit"
          (click)="toggleFullScreen(false)">
          <mat-icon style="margin: 0">fullscreen_exit</mat-icon>
        </button>

        <button
          type="button"
          mat-stroked-button
          matTooltip="Restore Default Wallboard"
          *ngIf="isEditing"
          (click)="restoreWallboard()">
          <mat-icon style="margin: 0">restore</mat-icon>
        </button>
        <button
          type="button"
          mat-stroked-button
          matTooltip="Cancel Changes"
          *ngIf="isEditing"
          (click)="cancelEditWallboard()">
          <mat-icon style="margin: 0">close</mat-icon>
        </button>
        <button
          type="button"
          mat-stroked-button
          matTooltip="Save Changes"
          color="primary"
          *ngIf="isEditing"
          (click)="saveWallboard()">
          Save
        </button>
      </div>
    </div>
  </div>
  <div class="gridster-container">
    <gridster class="wb-gridster" [options]="options">
      <gridster-item [item]="item" *ngFor="let item of dashboard">
        <app-pbx-wb-item
          [gridItem]="item"
          [itemData]="item.item?.data"
          [isEditing]="isEditing"
          (removeWidgetEvent)="onItemRemove($event)"
        ></app-pbx-wb-item>
      </gridster-item>
    </gridster>
  </div>
</div>
